import styled from 'styled-components';

export const Container = styled.label`
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
  margin: 0;
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: inherit;
  }

  .track {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 9px;
    background: ${(props) => props.theme.$gray400};
    transition: background 0.2s;
  }

  .track::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: ${(props) => props.theme.$white};
    transition: transform 0.2s;
  }

  input:checked + .track {
    background: ${(props) => props.theme.$success};
  }

  input:checked + .track::after {
    transform: translateX(16px);
  }

  input:focus + .track {
    box-shadow: 0 0 0 2px ${(props) => props.theme.$primary_medium};
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
